import { render, staticRenderFns } from "./_dataUpload.vue?vue&type=template&id=19fc495e&scoped=true"
import script from "./_dataUpload.vue?vue&type=script&lang=js"
export * from "./_dataUpload.vue?vue&type=script&lang=js"
import style0 from "./_dataUpload.vue?vue&type=style&index=0&id=19fc495e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc495e",
  null
  
)

export default component.exports